import * as types from "../types/foodTaxesMap"

const initialState = {}

const foodTaxesMap = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_FOOD_TAXES: {
      const newTaxesMap = {}

      action.taxes.forEach(tax => {
        newTaxesMap[tax._id] = tax
      })

      const newState = {
        ...state,
        ...newTaxesMap
      }

      return newState
    }
    case types.UPDATE_FOOD_TAXES: {
      const newState = { ...state }

      action.taxes.forEach(tax => {
        newState[tax._id] = tax
      })

      return newState
    }
    case types.DELETE_FOOD_TAXES:
      const newState = { ...state }

      action.taxIds.forEach(taxId => {
        delete newState[taxId]
      })

      return newState
    case types.CLEAR_FOOD_TAXES:
      return {}
    default:
      return state
  }
}

export default foodTaxesMap